/**
 * Move element at index `oldIndex` to index `newIndex`.
 */
export const moveElementByIndex = (
  arr: unknown[],
  oldIndex: number,
  newIndex: number,
) => {
  const resultArr = [...arr];
  const [itemToMove] = resultArr.splice(oldIndex, 1);
  resultArr.splice(newIndex, 0, itemToMove);
  return resultArr;
};
